import { gql } from '@apollo/client';
import LAST_EVALUATION_EVENT_FRAGMENT from '../fragments/lastEvaluationEventFragment';

const LAST_EVALUATION_EVENT_QUERY = gql`
  query lastEvaluationEvent($id: ID!) {
    study(id: $id) {
      id
      lastEvaluationEvent {
        ...LastEvaluationEventFragment
      }
    }
  }

  ${LAST_EVALUATION_EVENT_FRAGMENT}
`;

export default LAST_EVALUATION_EVENT_QUERY;
